import { db } from '../../../config/firebaseconfig'

export default function getStudentUA(user, assessmentId, { loading, success, error, setIndicator }, year) {
    if (user.role === 'Student') {
        // setIndicator({
        //     selectOptions: [],
        //     defaultValue: {}
        // })
        loading()
        let docId = user.id
        return db.collection('students').doc(docId).get()
            .then((userDoc) => {
                const user = userDoc.data()

                // if this assessment exists in the user's record, fetch the corresponding
                // userAssessment. (This userAssessment stores all of the data about a 
                // specific user's interactions with one assessment.) 
                if (user.assessments) {
                    if (user.assessments[assessmentId]) {
                        const userAssessmentId = user.assessments[assessmentId];
            
                        if(userAssessmentId.hasOwnProperty(year)) {
            
                          const userAssessmentId = user.assessments[assessmentId][year].userAssessmentId;
                          db.collection('userAssessments').doc(userAssessmentId).get()
                          .then((userAssessmentDoc) => {
                            const userAssessment = userAssessmentDoc.data()
                            const { displayName } = userAssessment.assessmentSet;

                            let currentYear = Number(year.split('sy')[1])
                            let nextYear = currentYear + 1

                            let option = { value: year, label: `${displayName} [${currentYear + "-" + nextYear}]` };

                        //   setIndicator({
                        //     selectOptions: [option],
                        //     defaultValue: option
                        // })

                            success(userAssessment)
                          })
                          .catch((err) => error(err))
                        }
                    }
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/getStudentUA.js